import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getRequest, patchRequest } from '../../../../helpers/axiosClient';

import actions from './actions';


export function* getTeamDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }

        yield put({
            type: actions.TEAM_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params?.data,
            selected: params.selected,
            extension: params.extension, skip: params.skip,
        });
    } catch (error) {
        yield put({ type: actions.TEAM_DETAILS_FAILURE });
        return error;
    }
}


export function* getBusinessDetails() {

    try {
        const response = yield call(() => getRequest('businessProfile'));
        yield put({
            type: actions.BUSINESS_DETAILS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({ type: actions.BUSINESS_DETAILS_FAILURE });
        return error;
    }
}



export function* postBusinessDetails(params) {
    try {
        const response = yield call(() => patchRequest(`businessProfile`, params.updateData));
        yield put({
            type: actions.UPDATE_BUSINESS_PROFILE_DETAILS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({ type: actions.UPDATE_BUSINESS_PROFILE_DETAILS_FAILURE, message: error?.response?.data });
        return error;
    }
}

export function* getAddressDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.ADDRESS_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.ADDRESS_DETAILS_FAILURE });
        return error;
    }
}

export function* getBusinessList(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.BUSINESS_LIST_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({ type: actions.BUSINESS_LIST_FAILURE });
        return error;
    }
}

export function* getCurrentSubscription() {
    try {
        const response = yield call(() => getRequest('currentSubscription'));
        //const response = yield call(() => getRequest('subscriptions?filter=' + encodeURIComponent(JSON.stringify(params.filter))));

        yield put({
            type: actions.SUBSCRIPTION_DETAILS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({ type: actions.SUBSCRIPTION_DETAILS_FAILURE });
        return error;
    }
}


export function* getParameter(params) {
    try {
        const response = yield call(() => getRequest(params.url));
        console.log(response.data);
        yield put({
            type: actions.PARAMETER_DETAILS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({ type: actions.PARAMETER_DETAILS_FAILURE });
        return error;
    }
}

export function* getCurrentOrder(params) {
    try {
        const response = yield call(() => getRequest(`${params.businessId}/subscriptionorder`));

        yield put({
            type: actions.SUBSCRIPTION_ORDER_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({ type: actions.SUBSCRIPTION_ORDER_FAILURE });
        return error;
    }
}

export function* getPaymentCheck(params) {
    try {
        const response = yield call(() => getRequest(`subscriptionPayments/${params.id}`));
        yield put({
            type: actions.PAYMENT_CHECK_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({ type: actions.PAYMENT_CHECK_FAILURE });
        return error;
    }
}

export function* getClearDetails() {
    yield put({
        type: actions.CLEAR_HOME_DETAILS_SUCCESS,
    });
}

export function* getClearPaymentCheck() {
    yield put({
        type: actions.CLEAR_PAYMENT_CHECK_SUCCESS,
    });
}


export default function* homeSaga() {
    yield all([
        takeEvery(actions.TEAM_DETAILS_START, getTeamDetails),
        takeEvery(actions.BUSINESS_DETAILS_START, getBusinessDetails),
        takeEvery(actions.UPDATE_BUSINESS_PROFILE_DETAILS_START, postBusinessDetails),
        takeEvery(actions.ADDRESS_DETAILS_START, getAddressDetails),
        takeEvery(actions.BUSINESS_LIST_START, getBusinessList),
        takeEvery(actions.SUBSCRIPTION_DETAILS_START, getCurrentSubscription),
        takeEvery(actions.PARAMETER_DETAILS_START, getParameter),
        takeEvery(actions.SUBSCRIPTION_ORDER_START, getCurrentOrder),
        takeEvery(actions.PAYMENT_CHECK_START, getPaymentCheck),
        takeEvery(actions.CLEAR_PAYMENT_CHECK_START, getClearPaymentCheck),
        takeEvery(actions.CLEAR_HOME_DETAILS_START, getClearDetails)
    ]);
}